import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import debounce from "lodash/debounce";

import Styled from "./styled";
import StyledContainer from "components/styled/StyledContainer";
import Input from "components/Input/Input";
import Table from "components/Table/Table";
import Button from "components/Button/Button";
import { contributionsStore } from "@/store/contributionsStore";
import { urlLocations, pathBuilder } from "routes/urlLocations";
import AppTable from "../styled/StyledTable";
import { MemberSelector } from "@/components/common/MemberSelector";

const Contributions = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  // Get contributions data and loading state from store
  const contributions = contributionsStore.contributions.use();
  const isLoading = contributionsStore.isLoading.use();

  // Load contributions on component mount
  useEffect(() => {
    contributionsStore.loadContributions();
  }, []);

  const debouncedSearch = debounce((value) => {
    if (value.trim()) {
      contributionsStore.searchContributions(value);
    } else {
      contributionsStore.loadContributions();
    }
  }, 500);

  const handleAddNew = () => {
    navigate(pathBuilder.contributionDetails('new'));
  };

  const handleRowClick = (record) => {
    navigate(pathBuilder.contributionDetails(record.id));
  };

  return (
    <Styled.Page>
      <StyledContainer>
        <Styled.Title>
          <FormattedMessage id="Contributions.Title" />
        </Styled.Title>
        <Styled.SearchField>
          <Input
            onChange={({ target }) => debouncedSearch(target?.value)}
            prefix={<SearchOutlined style={{ fontSize: 16 }} />}
            placeholder={formatMessage({
              id: "Contributions.SearchPlaceholder",
            })}
          />
        </Styled.SearchField>
        <Styled.ActionRow>
          <Styled.Subtitle>
            <FormattedMessage id={"Contributions.Subtitle"} />
          </Styled.Subtitle>
          <Button
            onClick={handleAddNew}
            uitype={"secondary"}
          >
            <FormattedMessage id={"Contributions.AddNew"} />
          </Button>
        </Styled.ActionRow>
        <AppTable>
          <Table
            loading={isLoading}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            dataSource={contributions}
            columns={COLUMNS}
          />
        </AppTable>
      </StyledContainer>
    </Styled.Page>
  );
};

const COLUMNS = [
  {
    title: <FormattedMessage id={"Contributions.Name"} />,
    dataIndex: "fullName",
    key: "fullName",
    sorter: (a, b) => a?.fullName?.localeCompare(b?.fullName),
  },
  {
    title: <FormattedMessage id={"Contributions.Church"} />,
    dataIndex: "church",
    key: "church",
    render: (field) => (
      <Styled.TableTitleRow>{field?.name}</Styled.TableTitleRow>
    ),
    sorter: (a, b) => a?.church?.name?.localeCompare(b?.church?.name),
  },
  {
    title: <FormattedMessage id={"Contributions.Father"} />,
    dataIndex: "father",
    key: "father",
    render: (field) => field?.name,
    sorter: (a, b) => a?.father?.name?.localeCompare(b?.father?.name),
  },
  //   {
  //     title: <FormattedMessage id={"Contributions.Reason"} />,
  //     dataIndex: "reason",
  //     key: "reason",
  //     sorter: (a, b) => a?.reason?.localeCompare(b?.reason),
  //   },
  {
    title: <FormattedMessage id={"Contributions.Amount"} />,
    dataIndex: "amount",
    key: "amount",
    sorter: (a, b) => a?.amount - b?.amount,
  },
];

export default Contributions;
